import { ValidateJSModel } from 'forms/shared/types';
import { hasYesOrNo } from 'models/validate';
import { ForeignActivitiesFutureModel } from './types';
import { foreignActivitiesFutureItemValidator } from './validators/item';

const foreignActivitiesFutureValidator: ValidateJSModel<ForeignActivitiesFutureModel> = {
  HasFutureActivity: { hasValue: { validator: hasYesOrNo } },

  List: (value, attributes) => {
    if (attributes?.HasFutureActivity?.value === 'Yes') {
      return {
        presence: true,
        accordion: { validator: foreignActivitiesFutureItemValidator },
      };
    }

    return {};
  },
};
export default foreignActivitiesFutureValidator;
